import { Form, Spin, Typography } from "antd/es";
import moment from "moment";
import { connect } from "react-redux";
import {
  Button,
  Header,
  HorizontalStack,
  Icon,
  KCol,
  KPanel,
  KRow,
  KTab,
  KTabItem,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  ProgressBar,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { ProjeDetay_ScreenBase } from "./projedetay-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class ProjeDetay_Screen extends ProjeDetay_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{ projedetay_261399_value: undefined }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <div
              style={
                {
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100%",
                } as any
              }
            >
              <Header
                key="-2"
                id="projedetay_header"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    paddingTop: 0,
                    paddingRight: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "rgba(68, 68, 68, 1)",
                  } as any
                }
              >
                <KRow
                  key="997986"
                  id="997986"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(9, 124, 176, 1)",
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="589562"
                    id="589562"
                    xs={20}
                    sm={20}
                    md={20}
                    lg={20}
                    xl={20}
                    xxl={20}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <VerticalStack
                      key="920977"
                      id="920977"
                      direction="vertical"
                      size={2}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="284288"
                        id="284288"
                        direction="horizontal"
                        size={5}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Label
                          key="271446"
                          id="271446"
                          value={
                            this.state.GET_PROJE_DETAY?.at?.(0)?.projeKodu ??
                            undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="547809"
                          id="547809"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            547809,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="585180"
                          id="585180"
                          value={
                            this.state.GET_PROJE_DETAY?.at?.(0)?.kategoriAdi ??
                            undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="471300"
                          id="471300"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            471300,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="480115"
                          id="480115"
                          value={
                            this.state.GET_PROJE_DETAY?.at?.(0)?.projeTipi ??
                            undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                      </HorizontalStack>
                      <HorizontalStack
                        key="312208"
                        id="312208"
                        direction="horizontal"
                        size={0}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Label
                          key="491925"
                          id="491925"
                          value={
                            this.state.GET_PROJE_DETAY?.at?.(0)?.projeAdi ??
                            undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 600,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="114330"
                          id="114330"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            114330,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 600,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                      </HorizontalStack>
                      <HorizontalStack
                        key="71236"
                        id="71236"
                        direction="horizontal"
                        size={2}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="151432"
                          id="151432"
                          iconName="person"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "rgba(217, 217, 217, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="135540"
                          id="135540"
                          value={
                            this.state.GET_PROJE_DETAY?.at?.(0)?.musteriAdi ??
                            undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 300,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="19253"
                          id="19253"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            19253,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 600,
                              fontSize: "12px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Icon
                          key="138416"
                          id="138416"
                          iconName="business"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "rgba(217, 217, 217, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="554247"
                          id="554247"
                          value={
                            this.state.GET_PROJE_DETAY?.at?.(0)?.musteriAdi ??
                            undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 300,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="551015"
                          id="551015"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            551015,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 600,
                              fontSize: "12px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Icon
                          key="985877"
                          id="985877"
                          iconName="calendar_month"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "rgba(217, 217, 217, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <HorizontalStack
                          key="751789"
                          id="751789"
                          direction="horizontal"
                          size={0}
                          overflowX="auto"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="470797"
                            id="470797"
                            value={
                              this.state.GET_PROJE_DETAY?.at?.(0)
                                ?.baslangicTarihi ?? undefined
                            }
                            formatter="date"
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontWeight: 300,
                                fontSize: "10px",
                                color: "rgba(255, 255, 255, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="321188"
                            id="321188"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              321188,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontWeight: 300,
                                fontSize: "10px",
                                color: "rgba(255, 255, 255, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="931176"
                            id="931176"
                            value={
                              this.state.GET_PROJE_DETAY?.at?.(0)
                                ?.tahminiBitis ?? undefined
                            }
                            formatter="date"
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontWeight: 300,
                                fontSize: "10px",
                                color: "rgba(255, 255, 255, 1)",
                              } as any
                            }
                          ></Label>
                        </HorizontalStack>
                      </HorizontalStack>
                    </VerticalStack>
                  </KCol>
                  <KCol
                    key="561047"
                    id="561047"
                    xs={4}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    xxl={4}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "center",
                        textAlign: "-webkit-right",
                      } as any
                    }
                  >
                    <VerticalStack
                      key="903177"
                      id="903177"
                      direction="vertical"
                      size={4}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <Icon
                        key="838016"
                        id="838016"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.ProjeDetayComponent_838016_onClick();
                        }}
                        showCursorPointer
                        iconName="close"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 1)",
                            letterSpacing: "1px",
                          } as any
                        }
                      ></Icon>
                    </VerticalStack>
                  </KCol>
                </KRow>
              </Header>
              <div
                key="-1"
                id="projedetay_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    display: "block",
                  } as any
                }
              >
                <KRow
                  key="586288"
                  id="586288"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="764741"
                    id="764741"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 8,
                        paddingBottom: 0,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <Label
                      key="52788"
                      id="52788"
                      value={ReactSystemFunctions.translate(
                        this.ml,
                        52788,
                        "value",
                        this.defaultML
                      )}
                      writingMode="horizontal"
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                          display: "inline",
                          fontWeight: 400,
                          fontSize: "10px",
                          color: "rgba(52, 73, 94, 1)",
                        } as any
                      }
                    ></Label>
                    <Form.Item
                      className="kFormItem"
                      name="projedetay_413736_value"
                      noStyle
                    >
                      <ProgressBar
                        key="413736"
                        id="413736"
                        percent={
                          this.state.GET_PROJE_DETAY?.at?.(0)
                            ?.ilerlemeYuzdesi ?? undefined
                        }
                        status="normal"
                        firstGradientColor="rgba(44, 62, 80, 1)"
                        secondGradientColor="rgba(52, 73, 94, 1)"
                        thirdGradientColor="rgba(13, 150, 212, 1)"
                        size="small"
                        hidePercentage={false}
                        percentageDirection="right"
                        direction="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            display: "block",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></ProgressBar>
                    </Form.Item>
                  </KCol>
                  <KCol
                    key="505771"
                    id="505771"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <Form.Item
                      className="kFormItem"
                      name="projedetay_261399_value"
                      noStyle
                    >
                      <KTab
                        key="261399"
                        id="261399"
                        onChange={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.ProjeDetayComponent_261399_onChange();
                        }}
                        type="line"
                        size="default"
                        tabPosition="top"
                        selectedTabColor="#0078FF"
                        justifiedTabTitles={false}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KTabItem
                          key={490554}
                          id="490554"
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            490554,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="475411"
                            id="475411"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                              } as any
                            }
                          >
                            <KCol
                              key="28477"
                              id="28477"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                } as any
                              }
                            >
                              <KRow
                                key="58742"
                                id="58742"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingBottom: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="309819"
                                  id="309819"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="934626"
                                    id="934626"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="378127"
                                      id="378127"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="27771"
                                        id="27771"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="999265"
                                          id="999265"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="370812"
                                            id="370812"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              370812,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="357914"
                                          id="357914"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        ></KCol>
                                      </KRow>
                                      <KRow
                                        key="125787"
                                        id="125787"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="485049"
                                          id="485049"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="873090"
                                            id="873090"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              873090,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="329271"
                                          id="329271"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="286346"
                                            id="286346"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.kategoriAdi ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="92680"
                                        id="92680"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="590159"
                                          id="590159"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="532359"
                                            id="532359"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              532359,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="821752"
                                          id="821752"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="301417"
                                            id="301417"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.gucKwp ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="368292"
                                        id="368292"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="954193"
                                          id="954193"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="488872"
                                            id="488872"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              488872,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="650616"
                                          id="650616"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="298959"
                                            id="298959"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.butce ?? undefined
                                            }
                                            formatter="money-tl"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="821933"
                                        id="821933"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="726756"
                                          id="726756"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="707335"
                                            id="707335"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              707335,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="364836"
                                          id="364836"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="725534"
                                            id="725534"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.netsisProjKodu ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                                <KCol
                                  key="387114"
                                  id="387114"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingRight: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="860116"
                                    id="860116"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="229691"
                                      id="229691"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="515824"
                                        id="515824"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="365698"
                                          id="365698"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="652581"
                                            id="652581"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              652581,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="450799"
                                          id="450799"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        ></KCol>
                                      </KRow>
                                      <KRow
                                        key="697919"
                                        id="697919"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="392952"
                                          id="392952"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="692080"
                                            id="692080"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              692080,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="530667"
                                          id="530667"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="82922"
                                            id="82922"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.musteriAdi ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="452229"
                                        id="452229"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="344225"
                                          id="344225"
                                          xs={8}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="756078"
                                            id="756078"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              756078,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="650610"
                                          id="650610"
                                          xs={16}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="548"
                                            id="548"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                -1
                                              )?.iletisimKisi ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="783022"
                                        id="783022"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="566733"
                                          id="566733"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="300522"
                                            id="300522"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              300522,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="59294"
                                          id="59294"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="21963"
                                            id="21963"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.telefon ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="271622"
                                        id="271622"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="940110"
                                          id="940110"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="695712"
                                            id="695712"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              695712,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="169556"
                                          id="169556"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="750631"
                                            id="750631"
                                            value={
                                              this.state.GET_PROJE_DETAY?.at?.(
                                                0
                                              )?.eposta ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="337615"
                                id="337615"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="542199"
                                  id="542199"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 0,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="458272"
                                    id="458272"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="858804"
                                      id="858804"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="809053"
                                        id="809053"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="230590"
                                          id="230590"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="852044"
                                            id="852044"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="47064"
                                              id="47064"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                47064,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="346352"
                                              id="346352"
                                              value={
                                                this.state.GET_PROJE_DETAY?.at?.(
                                                  0
                                                )?.adres ?? undefined
                                              }
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                                <KCol
                                  key="457735"
                                  id="457735"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 0,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="850424"
                                    id="850424"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="488869"
                                      id="488869"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="989463"
                                        id="989463"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="14922"
                                          id="14922"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="644014"
                                            id="644014"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              644014,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                          <KRow
                                            key="498961"
                                            id="498961"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="628845"
                                              id="628845"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingLeft: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="215545"
                                                id="215545"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="214280"
                                                  id="214280"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="94007"
                                                    id="94007"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="228771"
                                                      id="228771"
                                                      iconName="storefront"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(199, 56, 50, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="518329"
                                                      id="518329"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        518329,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="797429"
                                                      id="797429"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="755118"
                                                        id="755118"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.satis_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="550139"
                                                        id="550139"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          550139,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="476856"
                                                        id="476856"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.satis_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="196734"
                                              id="196734"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="582078"
                                                id="582078"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="240236"
                                                  id="240236"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="612873"
                                                    id="612873"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="330393"
                                                      id="330393"
                                                      iconName="insert_chart"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(114, 194, 64, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="531520"
                                                      id="531520"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        531520,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="525638"
                                                      id="525638"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="369169"
                                                        id="369169"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )
                                                            ?.muhasebe_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="939493"
                                                        id="939493"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          939493,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="946524"
                                                        id="946524"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.muhasebe_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="690505"
                                              id="690505"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="325611"
                                                id="325611"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="824176"
                                                  id="824176"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="310182"
                                                    id="310182"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="920773"
                                                      id="920773"
                                                      iconName="shape_line"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="10258"
                                                      id="10258"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        10258,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="247844"
                                                      id="247844"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="235644"
                                                        id="235644"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.proje_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="420784"
                                                        id="420784"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          420784,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="986115"
                                                        id="986115"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.proje_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="629131"
                                              id="629131"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="189980"
                                                id="189980"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="219318"
                                                  id="219318"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="96191"
                                                    id="96191"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="307330"
                                                      id="307330"
                                                      iconName="add_shopping_cart"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(140, 140, 140, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="474956"
                                                      id="474956"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        474956,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="86487"
                                                      id="86487"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="373122"
                                                        id="373122"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            -1
                                                          )
                                                            ?.satinalma_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="800931"
                                                        id="800931"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          800931,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="724803"
                                                        id="724803"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.satis_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="201002"
                                            id="201002"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 8,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="169804"
                                              id="169804"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="451066"
                                                id="451066"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="851781"
                                                  id="851781"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="469559"
                                                    id="469559"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="72432"
                                                      id="72432"
                                                      iconName="support_agent"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(199, 56, 50, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="979930"
                                                      id="979930"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        979930,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="531903"
                                                      id="531903"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="634450"
                                                        id="634450"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.mtS_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="114456"
                                                        id="114456"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          114456,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="898355"
                                                        id="898355"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.mtS_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="474391"
                                              id="474391"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="258616"
                                                id="258616"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="387954"
                                                  id="387954"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="688489"
                                                    id="688489"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="446908"
                                                      id="446908"
                                                      iconName="warehouse"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(114, 194, 64, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="389472"
                                                      id="389472"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        389472,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="978317"
                                                      id="978317"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="268979"
                                                        id="268979"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.depo_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="394017"
                                                        id="394017"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          394017,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="769989"
                                                        id="769989"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.depo_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="964875"
                                              id="964875"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="537314"
                                                id="537314"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="109646"
                                                  id="109646"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="965793"
                                                    id="965793"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="118233"
                                                      id="118233"
                                                      iconName="campaign"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="820460"
                                                      id="820460"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        820460,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="98664"
                                                      id="98664"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="327184"
                                                        id="327184"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )
                                                            ?.pazarlama_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="331011"
                                                        id="331011"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          331011,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="745167"
                                                        id="745167"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.pazarlama_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="954354"
                                              id="954354"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="607963"
                                                id="607963"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="427593"
                                                  id="427593"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="249437"
                                                    id="249437"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="74190"
                                                      id="74190"
                                                      iconName="production_quantity_limits"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(140, 140, 140, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="30057"
                                                      id="30057"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        30057,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="455659"
                                                      id="455659"
                                                      direction="horizontal"
                                                      size={0}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="995977"
                                                        id="995977"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.ariza_Tamamlanan ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="151825"
                                                        id="151825"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          151825,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 0,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="502678"
                                                        id="502678"
                                                        value={
                                                          this.state.GET_PROJE_BIRIM_DURUMLAR?.at?.(
                                                            0
                                                          )?.ariza_Toplam ??
                                                          undefined
                                                        }
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.22)",
                                                            paddingTop: 4,
                                                            paddingRight: 8,
                                                            paddingBottom: 4,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "9px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                        <KTabItem
                          key={367991}
                          id="367991"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.ProjeDetayComponent_367991_onActive();
                          }}
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            367991,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="26535"
                            id="26535"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                              } as any
                            }
                          >
                            <KCol
                              key="419698"
                              id="419698"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                } as any
                              }
                            >
                              <KRow
                                key="518662"
                                id="518662"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="764711"
                                  id="764711"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="901060"
                                    id="901060"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(172, 215, 70, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(172, 215, 70, 0.22)",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="556011"
                                      id="556011"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="816090"
                                        id="816090"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="292685"
                                          id="292685"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="405947"
                                            id="405947"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={16}
                                            xxl={16}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                alignItems: "center",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="579440"
                                              id="579440"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="759791"
                                                id="759791"
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                lg={2}
                                                xl={2}
                                                xxl={2}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="87604"
                                                  id="87604"
                                                  iconName="biotech"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(225, 60, 57, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                              <KCol
                                                key="301374"
                                                id="301374"
                                                xs={22}
                                                sm={22}
                                                md={22}
                                                lg={22}
                                                xl={22}
                                                xxl={22}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                  } as any
                                                }
                                              >
                                                <VerticalStack
                                                  key="906531"
                                                  id="906531"
                                                  direction="vertical"
                                                  size={2}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <HorizontalStack
                                                    key="53477"
                                                    id="53477"
                                                    direction="horizontal"
                                                    size={12}
                                                    overflowX="auto"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="656531"
                                                      id="656531"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        656531,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="796332"
                                                      id="796332"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        796332,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 999,
                                                          borderTopRightRadius: 999,
                                                          borderBottomRightRadius: 999,
                                                          borderBottomLeftRadius: 999,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 8,
                                                          paddingRight: 12,
                                                          paddingBottom: 8,
                                                          paddingLeft: 12,
                                                          maxWidth: "100px",
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          lineHeight: "1px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </HorizontalStack>
                                                  <Label
                                                    key="625172"
                                                    id="625172"
                                                    value={
                                                      this.state.GET_PROJE_ON_SUREC?.at?.(
                                                        0
                                                      )?.onKesif_Notu ??
                                                      undefined
                                                    }
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontWeight: 400,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </VerticalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="47989"
                                            id="47989"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={8}
                                            xxl={8}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="945792"
                                              id="945792"
                                              direction="vertical"
                                              size={1}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  textAlign: "-webkit-center",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="814648"
                                                id="814648"
                                                value="[datafield:durum]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 999,
                                                    borderTopRightRadius: 999,
                                                    borderBottomRightRadius: 999,
                                                    borderBottomLeftRadius: 999,
                                                    backgroundColor:
                                                      "rgba(114, 194, 64, 0.32)",
                                                    paddingTop: 12,
                                                    paddingRight: 12,
                                                    paddingBottom: 12,
                                                    paddingLeft: 12,
                                                    maxWidth: "100px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "9px",
                                                    color:
                                                      "rgba(114, 194, 64, 1)",
                                                    lineHeight: "1px",
                                                  } as any
                                                }
                                              ></Label>
                                              <HorizontalStack
                                                key="56395"
                                                id="56395"
                                                direction="horizontal"
                                                size={0}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="616113"
                                                  id="616113"
                                                  value={
                                                    this.state.GET_PROJE_ON_SUREC?.at?.(
                                                      0
                                                    )?.onKesif_Kullanici ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="717071"
                                                  id="717071"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    717071,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "10px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="132051"
                                                  id="132051"
                                                  value={
                                                    this.state.GET_PROJE_ON_SUREC?.at?.(
                                                      0
                                                    )?.onKesif_Tarih ??
                                                    undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <Button
                                                key="387411"
                                                id="387411"
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  387411,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="remove_red_eye"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 200,
                                                    borderTopRightRadius: 200,
                                                    borderBottomRightRadius: 200,
                                                    borderBottomLeftRadius: 200,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(13, 150, 212, 0.9)",
                                                    backgroundColor:
                                                      "transparent",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color:
                                                      "rgba(13, 150, 212, 1)",
                                                  } as any
                                                }
                                              ></Button>
                                            </VerticalStack>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KCol>
                                <KCol
                                  key="921701"
                                  id="921701"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="196867"
                                    id="196867"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(172, 215, 70, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(172, 215, 70, 0.22)",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="471146"
                                      id="471146"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="570144"
                                        id="570144"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="988100"
                                          id="988100"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="107284"
                                            id="107284"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={16}
                                            xxl={16}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                alignItems: "center",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="248000"
                                              id="248000"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="199203"
                                                id="199203"
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                lg={2}
                                                xl={2}
                                                xxl={2}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="686077"
                                                  id="686077"
                                                  iconName="assignment"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(225, 60, 57, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                              <KCol
                                                key="136734"
                                                id="136734"
                                                xs={22}
                                                sm={22}
                                                md={22}
                                                lg={22}
                                                xl={22}
                                                xxl={22}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                  } as any
                                                }
                                              >
                                                <VerticalStack
                                                  key="995864"
                                                  id="995864"
                                                  direction="vertical"
                                                  size={2}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <HorizontalStack
                                                    key="144838"
                                                    id="144838"
                                                    direction="horizontal"
                                                    size={12}
                                                    overflowX="auto"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="620303"
                                                      id="620303"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        620303,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="386387"
                                                      id="386387"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        386387,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 999,
                                                          borderTopRightRadius: 999,
                                                          borderBottomRightRadius: 999,
                                                          borderBottomLeftRadius: 999,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 8,
                                                          paddingRight: 12,
                                                          paddingBottom: 8,
                                                          paddingLeft: 12,
                                                          maxWidth: "100px",
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          lineHeight: "1px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </HorizontalStack>
                                                  <Label
                                                    key="313289"
                                                    id="313289"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      313289,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontWeight: 400,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </VerticalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="957469"
                                            id="957469"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={8}
                                            xxl={8}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="437219"
                                              id="437219"
                                              direction="vertical"
                                              size={1}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  textAlign: "-webkit-center",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="57916"
                                                id="57916"
                                                value="[datafield:durum]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 999,
                                                    borderTopRightRadius: 999,
                                                    borderBottomRightRadius: 999,
                                                    borderBottomLeftRadius: 999,
                                                    backgroundColor:
                                                      "rgba(114, 194, 64, 0.32)",
                                                    paddingTop: 12,
                                                    paddingRight: 12,
                                                    paddingBottom: 12,
                                                    paddingLeft: 12,
                                                    maxWidth: "100px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "9px",
                                                    color:
                                                      "rgba(114, 194, 64, 1)",
                                                    lineHeight: "1px",
                                                  } as any
                                                }
                                              ></Label>
                                              <HorizontalStack
                                                key="454825"
                                                id="454825"
                                                direction="horizontal"
                                                size={0}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="852469"
                                                  id="852469"
                                                  value={
                                                    this.state.GET_PROJE_DETAY?.at?.(
                                                      0
                                                    )?.musteriAdi ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="674947"
                                                  id="674947"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    674947,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "10px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="643691"
                                                  id="643691"
                                                  value={moment().format(
                                                    "YYYY-MM-DDTHH:mm:ss"
                                                  )}
                                                  formatter="datetime"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <Button
                                                key="774399"
                                                id="774399"
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  774399,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="remove_red_eye"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 200,
                                                    borderTopRightRadius: 200,
                                                    borderBottomRightRadius: 200,
                                                    borderBottomLeftRadius: 200,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(13, 150, 212, 0.9)",
                                                    backgroundColor:
                                                      "transparent",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color:
                                                      "rgba(13, 150, 212, 1)",
                                                  } as any
                                                }
                                              ></Button>
                                            </VerticalStack>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KCol>
                                <KCol
                                  key="738980"
                                  id="738980"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="969601"
                                    id="969601"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(172, 215, 70, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(172, 215, 70, 0.22)",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="641149"
                                      id="641149"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="793232"
                                        id="793232"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="563580"
                                          id="563580"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="386271"
                                            id="386271"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={16}
                                            xxl={16}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                alignItems: "center",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="930663"
                                              id="930663"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="202167"
                                                id="202167"
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                lg={2}
                                                xl={2}
                                                xxl={2}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="507326"
                                                  id="507326"
                                                  iconName="assignment"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(225, 60, 57, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                              <KCol
                                                key="48485"
                                                id="48485"
                                                xs={22}
                                                sm={22}
                                                md={22}
                                                lg={22}
                                                xl={22}
                                                xxl={22}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                  } as any
                                                }
                                              >
                                                <VerticalStack
                                                  key="112068"
                                                  id="112068"
                                                  direction="vertical"
                                                  size={2}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <HorizontalStack
                                                    key="463321"
                                                    id="463321"
                                                    direction="horizontal"
                                                    size={12}
                                                    overflowX="auto"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="74137"
                                                      id="74137"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        74137,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="571228"
                                                      id="571228"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        571228,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 999,
                                                          borderTopRightRadius: 999,
                                                          borderBottomRightRadius: 999,
                                                          borderBottomLeftRadius: 999,
                                                          backgroundColor:
                                                            "rgba(106, 50, 201, 0.22)",
                                                          paddingTop: 8,
                                                          paddingRight: 12,
                                                          paddingBottom: 8,
                                                          paddingLeft: 12,
                                                          maxWidth: "100px",
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(106, 50, 201, 1)",
                                                          lineHeight: "1px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </HorizontalStack>
                                                  <Label
                                                    key="361937"
                                                    id="361937"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      361937,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontWeight: 400,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </VerticalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="475252"
                                            id="475252"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={8}
                                            xxl={8}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="849478"
                                              id="849478"
                                              direction="vertical"
                                              size={1}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  textAlign: "-webkit-center",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="555820"
                                                id="555820"
                                                value="[datafield:durum]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 999,
                                                    borderTopRightRadius: 999,
                                                    borderBottomRightRadius: 999,
                                                    borderBottomLeftRadius: 999,
                                                    backgroundColor:
                                                      "rgba(114, 194, 64, 0.32)",
                                                    paddingTop: 12,
                                                    paddingRight: 12,
                                                    paddingBottom: 12,
                                                    paddingLeft: 12,
                                                    maxWidth: "100px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "9px",
                                                    color:
                                                      "rgba(114, 194, 64, 1)",
                                                    lineHeight: "1px",
                                                  } as any
                                                }
                                              ></Label>
                                              <HorizontalStack
                                                key="970315"
                                                id="970315"
                                                direction="horizontal"
                                                size={0}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="43310"
                                                  id="43310"
                                                  value={
                                                    this.state.GET_PROJE_DETAY?.at?.(
                                                      0
                                                    )?.musteriAdi ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="751342"
                                                  id="751342"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    751342,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "10px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="182814"
                                                  id="182814"
                                                  value={moment().format(
                                                    "YYYY-MM-DDTHH:mm:ss"
                                                  )}
                                                  formatter="datetime"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <Button
                                                key="311100"
                                                id="311100"
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  311100,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="remove_red_eye"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 200,
                                                    borderTopRightRadius: 200,
                                                    borderBottomRightRadius: 200,
                                                    borderBottomLeftRadius: 200,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(13, 150, 212, 0.9)",
                                                    backgroundColor:
                                                      "transparent",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color:
                                                      "rgba(13, 150, 212, 1)",
                                                  } as any
                                                }
                                              ></Button>
                                            </VerticalStack>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KCol>
                                <KCol
                                  key="939697"
                                  id="939697"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="989555"
                                    id="989555"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(172, 215, 70, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(172, 215, 70, 0.22)",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="433633"
                                      id="433633"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="277513"
                                        id="277513"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="399810"
                                          id="399810"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="784364"
                                            id="784364"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={16}
                                            xxl={16}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                alignItems: "center",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="395289"
                                              id="395289"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="898142"
                                                id="898142"
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                lg={2}
                                                xl={2}
                                                xxl={2}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="623396"
                                                  id="623396"
                                                  iconName="account_tree"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(225, 60, 57, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                              <KCol
                                                key="401988"
                                                id="401988"
                                                xs={22}
                                                sm={22}
                                                md={22}
                                                lg={22}
                                                xl={22}
                                                xxl={22}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                  } as any
                                                }
                                              >
                                                <VerticalStack
                                                  key="46405"
                                                  id="46405"
                                                  direction="vertical"
                                                  size={2}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <HorizontalStack
                                                    key="605137"
                                                    id="605137"
                                                    direction="horizontal"
                                                    size={12}
                                                    overflowX="auto"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="157937"
                                                      id="157937"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        157937,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="245671"
                                                      id="245671"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        245671,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 999,
                                                          borderTopRightRadius: 999,
                                                          borderBottomRightRadius: 999,
                                                          borderBottomLeftRadius: 999,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 8,
                                                          paddingRight: 12,
                                                          paddingBottom: 8,
                                                          paddingLeft: 12,
                                                          maxWidth: "100px",
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          lineHeight: "1px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </HorizontalStack>
                                                  <Label
                                                    key="278512"
                                                    id="278512"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      278512,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontWeight: 400,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </VerticalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="680474"
                                            id="680474"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={8}
                                            xxl={8}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="729195"
                                              id="729195"
                                              direction="vertical"
                                              size={1}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  textAlign: "-webkit-center",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="281820"
                                                id="281820"
                                                value="[datafield:durum]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 999,
                                                    borderTopRightRadius: 999,
                                                    borderBottomRightRadius: 999,
                                                    borderBottomLeftRadius: 999,
                                                    backgroundColor:
                                                      "rgba(114, 194, 64, 0.32)",
                                                    paddingTop: 12,
                                                    paddingRight: 12,
                                                    paddingBottom: 12,
                                                    paddingLeft: 12,
                                                    maxWidth: "100px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "9px",
                                                    color:
                                                      "rgba(114, 194, 64, 1)",
                                                    lineHeight: "1px",
                                                  } as any
                                                }
                                              ></Label>
                                              <HorizontalStack
                                                key="538796"
                                                id="538796"
                                                direction="horizontal"
                                                size={0}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="500257"
                                                  id="500257"
                                                  value={
                                                    this.state.GET_PROJE_DETAY?.at?.(
                                                      0
                                                    )?.musteriAdi ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="42965"
                                                  id="42965"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    42965,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "10px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="293200"
                                                  id="293200"
                                                  value={moment().format(
                                                    "YYYY-MM-DDTHH:mm:ss"
                                                  )}
                                                  formatter="datetime"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <Button
                                                key="565640"
                                                id="565640"
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  565640,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="remove_red_eye"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 200,
                                                    borderTopRightRadius: 200,
                                                    borderBottomRightRadius: 200,
                                                    borderBottomLeftRadius: 200,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(13, 150, 212, 0.9)",
                                                    backgroundColor:
                                                      "transparent",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color:
                                                      "rgba(13, 150, 212, 1)",
                                                  } as any
                                                }
                                              ></Button>
                                            </VerticalStack>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KCol>
                                <KCol
                                  key="488932"
                                  id="488932"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="620335"
                                    id="620335"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(172, 215, 70, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(172, 215, 70, 0.22)",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="428031"
                                      id="428031"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="454917"
                                        id="454917"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="947747"
                                          id="947747"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="78873"
                                            id="78873"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={16}
                                            xxl={16}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                alignItems: "center",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="215129"
                                              id="215129"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="166314"
                                                id="166314"
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                lg={2}
                                                xl={2}
                                                xxl={2}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="174146"
                                                  id="174146"
                                                  iconName="fingerprint"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(225, 60, 57, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                              <KCol
                                                key="263410"
                                                id="263410"
                                                xs={22}
                                                sm={22}
                                                md={22}
                                                lg={22}
                                                xl={22}
                                                xxl={22}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                  } as any
                                                }
                                              >
                                                <VerticalStack
                                                  key="488167"
                                                  id="488167"
                                                  direction="vertical"
                                                  size={2}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <HorizontalStack
                                                    key="201060"
                                                    id="201060"
                                                    direction="horizontal"
                                                    size={12}
                                                    overflowX="auto"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="650582"
                                                      id="650582"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        650582,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="741290"
                                                      id="741290"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        741290,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 999,
                                                          borderTopRightRadius: 999,
                                                          borderBottomRightRadius: 999,
                                                          borderBottomLeftRadius: 999,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 8,
                                                          paddingRight: 12,
                                                          paddingBottom: 8,
                                                          paddingLeft: 12,
                                                          maxWidth: "100px",
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          lineHeight: "1px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </HorizontalStack>
                                                  <Label
                                                    key="815026"
                                                    id="815026"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      815026,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontWeight: 400,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </VerticalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="224563"
                                            id="224563"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={8}
                                            xxl={8}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="333864"
                                              id="333864"
                                              direction="vertical"
                                              size={1}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  textAlign: "-webkit-center",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="831717"
                                                id="831717"
                                                value="[datafield:durum]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 999,
                                                    borderTopRightRadius: 999,
                                                    borderBottomRightRadius: 999,
                                                    borderBottomLeftRadius: 999,
                                                    backgroundColor:
                                                      "rgba(114, 194, 64, 0.32)",
                                                    paddingTop: 12,
                                                    paddingRight: 12,
                                                    paddingBottom: 12,
                                                    paddingLeft: 12,
                                                    maxWidth: "100px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "9px",
                                                    color:
                                                      "rgba(114, 194, 64, 1)",
                                                    lineHeight: "1px",
                                                  } as any
                                                }
                                              ></Label>
                                              <HorizontalStack
                                                key="682290"
                                                id="682290"
                                                direction="horizontal"
                                                size={0}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="204047"
                                                  id="204047"
                                                  value={
                                                    this.state.GET_PROJE_DETAY?.at?.(
                                                      0
                                                    )?.musteriAdi ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="382963"
                                                  id="382963"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    382963,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "10px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="373292"
                                                  id="373292"
                                                  value={moment().format(
                                                    "YYYY-MM-DDTHH:mm:ss"
                                                  )}
                                                  formatter="datetime"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontWeight: 500,
                                                      fontSize: "10px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <Button
                                                key="180592"
                                                id="180592"
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  180592,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="remove_red_eye"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 200,
                                                    borderTopRightRadius: 200,
                                                    borderBottomRightRadius: 200,
                                                    borderBottomLeftRadius: 200,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(13, 150, 212, 0.9)",
                                                    backgroundColor:
                                                      "transparent",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color:
                                                      "rgba(13, 150, 212, 1)",
                                                  } as any
                                                }
                                              ></Button>
                                            </VerticalStack>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KCol>
                                <KCol
                                  key="114558"
                                  id="114558"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                ></KCol>
                              </KRow>
                              <KRow
                                key="698695"
                                id="698695"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="981515"
                                  id="981515"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 8,
                                      paddingBottom: 0,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="830383"
                                    id="830383"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(106, 50, 201, 0.32)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(106, 50, 201, 0.12)",
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="902230"
                                      id="902230"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="395703"
                                        id="395703"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={1}
                                        xxl={1}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-center",
                                          } as any
                                        }
                                      >
                                        <Icon
                                          key="175897"
                                          id="175897"
                                          iconName="info_outline"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "20px",
                                              color: "rgba(13, 150, 212, 1)",
                                              letterSpacing: "1px",
                                            } as any
                                          }
                                        ></Icon>
                                      </KCol>
                                      <KCol
                                        key="183716"
                                        id="183716"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={23}
                                        xxl={23}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="243432"
                                          id="243432"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="975192"
                                            id="975192"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="823496"
                                              id="823496"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                823496,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontWeight: 500,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(106, 50, 201, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="807533"
                                              id="807533"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                807533,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 2,
                                                  paddingBottom: 0,
                                                  paddingLeft: 2,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontWeight: 700,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(106, 50, 201, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="264587"
                                              id="264587"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                264587,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontWeight: 500,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(106, 50, 201, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                        <KTabItem
                          key={832682}
                          id="832682"
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            832682,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KTable
                            key="891482"
                            id="891482"
                            kuikaRef={
                              this.projedetay_891482_value_kuikaTableRef
                            }
                            form={this.props.form}
                            dataSource={this.state.GET_PROJE_ASAMALAR_DURUM}
                            size="middle"
                            bordered={true}
                            loading={false}
                            rowKey="id"
                            transformedOnMobileResolution={false}
                            hideHeaderOnMobileResolution={false}
                            showHeader={false}
                            fixedHeader={false}
                            tableWidthMode="fit"
                            editable={false}
                            editableAlwaysActive={false}
                            insertRowActive={false}
                            insertRowPosition="top"
                            globalSearch={false}
                            searchable={false}
                            shouldSearchOnChange={true}
                            searchDelay={200}
                            sorter={false}
                            filtering={false}
                            resizableColumns={false}
                            pagination={true}
                            pageSize={10}
                            showSizeChanger={false}
                            paginationSelectedTextColor="#246eff"
                            paginationUnselectedTextColor="#000"
                            columnChooser={false}
                            striped={false}
                            stripedColor="#F5F7FA"
                            rowHoverBgColor="#fafafa"
                            showRowNumbers={false}
                            showNoDataFound={true}
                            nodatafoundmessage={ReactSystemFunctions.translate(
                              this.ml,
                              891482,
                              "nodatafoundmessage",
                              this.defaultML
                            )}
                            multiSelect={false}
                            multiSelectScope="page"
                            export={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KTableHeader
                              key="961397"
                              id="961397"
                              hideOnMobileResolution={false}
                              textDirection="Default"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "12px",
                                  color: "rgba(155, 155, 155, 1)",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KTableHeader>
                            <KTableRow
                              key="684628"
                              id="684628"
                              hoverFontColor="red"
                              hoverBgColor="#F5F5F5"
                              style={
                                {
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTableColumn
                                key="816640"
                                id="816640"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  816640,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KPanel
                                  key="952390"
                                  id="952390"
                                  scrolling="hidden"
                                  scrollRadius={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 12,
                                      borderTopRightRadius: 12,
                                      borderBottomRightRadius: 12,
                                      borderBottomLeftRadius: 12,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor:
                                        "rgba(164, 199, 79, 0.22)",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="641294"
                                    id="641294"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="663359"
                                      id="663359"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={12}
                                      xxl={12}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <HorizontalStack
                                        key="313478"
                                        id="313478"
                                        direction="horizontal"
                                        size={12}
                                        overflowX="auto"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Icon
                                          key="695727"
                                          id="695727"
                                          iconName="done"
                                          style={
                                            {
                                              borderTopLeftRadius: 200,
                                              borderTopRightRadius: 200,
                                              borderBottomRightRadius: 200,
                                              borderBottomLeftRadius: 200,
                                              backgroundColor:
                                                "rgba(114, 194, 64, 1)",
                                              paddingTop: 2,
                                              paddingRight: 2,
                                              paddingBottom: 2,
                                              paddingLeft: 2,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "16px",
                                              color: "rgba(255, 255, 255, 1)",
                                              letterSpacing: "1px",
                                            } as any
                                          }
                                        ></Icon>
                                        <VerticalStack
                                          key="522627"
                                          id="522627"
                                          direction="vertical"
                                          size={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="196767"
                                            id="196767"
                                            value="[datafield:asamaAdi]"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                          <HorizontalStack
                                            key="353131"
                                            id="353131"
                                            direction="horizontal"
                                            size={5}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="41749"
                                              id="41749"
                                              value="[datafield:tamamlayanAdi]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "10px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="240537"
                                              id="240537"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                240537,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "10px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="117789"
                                              id="117789"
                                              value="[datafield:tamamlanmaTarihi]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "10px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </VerticalStack>
                                      </HorizontalStack>
                                    </KCol>
                                    <KCol
                                      key="61212"
                                      id="61212"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={12}
                                      xxl={12}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    >
                                      <HorizontalStack
                                        key="97298"
                                        id="97298"
                                        direction="horizontal"
                                        size={0}
                                        overflowX="auto"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="951113"
                                          id="951113"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            951113,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              width: "100px",
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Montserrat",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(13, 150, 212, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Label
                                          key="705958"
                                          id="705958"
                                          value="[datafield:yuzde]"
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              width: "100px",
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Montserrat",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(13, 150, 212, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Label
                                          key="962033"
                                          id="962033"
                                          value="[datafield:durum]"
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderTopLeftRadius: 999,
                                              borderTopRightRadius: 999,
                                              borderBottomRightRadius: 999,
                                              borderBottomLeftRadius: 999,
                                              backgroundColor:
                                                "rgba(114, 194, 64, 1)",
                                              paddingTop: 12,
                                              paddingRight: 12,
                                              paddingBottom: 12,
                                              paddingLeft: 12,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "9px",
                                              color: "rgba(0, 0, 0, 1)",
                                              lineHeight: "1px",
                                            } as any
                                          }
                                        ></Label>
                                      </HorizontalStack>
                                    </KCol>
                                  </KRow>
                                </KPanel>
                              </KTableColumn>
                            </KTableRow>
                          </KTable>
                        </KTabItem>
                        <KTabItem
                          key={899938}
                          id="899938"
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            899938,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></KTabItem>
                        <KTabItem
                          key={442005}
                          id="442005"
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            442005,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="181082"
                            id="181082"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                              } as any
                            }
                          >
                            <KCol
                              key="464030"
                              id="464030"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                } as any
                              }
                            >
                              <KRow
                                key="230060"
                                id="230060"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="129594"
                                  id="129594"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="399849"
                                    id="399849"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="75642"
                                      id="75642"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="652784"
                                        id="652784"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="160244"
                                          id="160244"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="626472"
                                            id="626472"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              626472,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="755322"
                                          id="755322"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        ></KCol>
                                      </KRow>
                                      <KRow
                                        key="58805"
                                        id="58805"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="683853"
                                          id="683853"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="481113"
                                            id="481113"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              481113,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="817069"
                                          id="817069"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="704541"
                                            id="704541"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              704541,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="229513"
                                        id="229513"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="446994"
                                          id="446994"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="733704"
                                            id="733704"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              733704,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="244567"
                                          id="244567"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="741508"
                                            id="741508"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              741508,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="261623"
                                        id="261623"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="331489"
                                          id="331489"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="448136"
                                            id="448136"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              448136,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="573148"
                                          id="573148"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="126357"
                                            id="126357"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              126357,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="190305"
                                        id="190305"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="654402"
                                          id="654402"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="275607"
                                            id="275607"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              275607,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="41474"
                                          id="41474"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="355158"
                                            id="355158"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              355158,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                                <KCol
                                  key="183259"
                                  id="183259"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="496491"
                                    id="496491"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="451123"
                                      id="451123"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="832745"
                                        id="832745"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="10397"
                                          id="10397"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="895510"
                                            id="895510"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              895510,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="70770"
                                          id="70770"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        ></KCol>
                                      </KRow>
                                      <KRow
                                        key="128973"
                                        id="128973"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="64496"
                                          id="64496"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="760601"
                                            id="760601"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              760601,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="182909"
                                          id="182909"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="664254"
                                            id="664254"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              664254,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="43"
                                        id="43"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="353469"
                                          id="353469"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="314114"
                                            id="314114"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              314114,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="117621"
                                          id="117621"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="295506"
                                            id="295506"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              295506,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="938095"
                                        id="938095"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="925346"
                                          id="925346"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="180244"
                                            id="180244"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              180244,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="512145"
                                          id="512145"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="544535"
                                            id="544535"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              544535,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="860069"
                                        id="860069"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="304125"
                                          id="304125"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="818771"
                                            id="818771"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              818771,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="727601"
                                          id="727601"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="405505"
                                            id="405505"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              405505,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="876440"
                                id="876440"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="155281"
                                  id="155281"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="798112"
                                    id="798112"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="942075"
                                      id="942075"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="921200"
                                        id="921200"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="572932"
                                          id="572932"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="280233"
                                            id="280233"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="387266"
                                              id="387266"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                387266,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="657407"
                                              id="657407"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                657407,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                                <KCol
                                  key="443393"
                                  id="443393"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="5499"
                                    id="5499"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="639210"
                                      id="639210"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="171541"
                                        id="171541"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="279040"
                                          id="279040"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="434141"
                                            id="434141"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              434141,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                          <KRow
                                            key="670629"
                                            id="670629"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="940204"
                                              id="940204"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="612754"
                                                id="612754"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="503781"
                                                  id="503781"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="287597"
                                                    id="287597"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="405687"
                                                      id="405687"
                                                      iconName="storefront"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(199, 56, 50, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="547881"
                                                      id="547881"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        547881,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="762535"
                                                      id="762535"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        762535,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 200,
                                                          borderTopRightRadius: 200,
                                                          borderBottomRightRadius: 200,
                                                          borderBottomLeftRadius: 200,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 4,
                                                          paddingRight: 8,
                                                          paddingBottom: 4,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="230774"
                                              id="230774"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="628433"
                                                id="628433"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="276197"
                                                  id="276197"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="291462"
                                                    id="291462"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="850518"
                                                      id="850518"
                                                      iconName="insert_chart"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(114, 194, 64, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="790249"
                                                      id="790249"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        790249,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="77163"
                                                      id="77163"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        77163,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 200,
                                                          borderTopRightRadius: 200,
                                                          borderBottomRightRadius: 200,
                                                          borderBottomLeftRadius: 200,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 4,
                                                          paddingRight: 8,
                                                          paddingBottom: 4,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="218270"
                                              id="218270"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="231354"
                                                id="231354"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="589209"
                                                  id="589209"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="454263"
                                                    id="454263"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="255243"
                                                      id="255243"
                                                      iconName="shape_line"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="373110"
                                                      id="373110"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        373110,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="851748"
                                                      id="851748"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        851748,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 200,
                                                          borderTopRightRadius: 200,
                                                          borderBottomRightRadius: 200,
                                                          borderBottomLeftRadius: 200,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 4,
                                                          paddingRight: 8,
                                                          paddingBottom: 4,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="796265"
                                              id="796265"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="826055"
                                                id="826055"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="806938"
                                                  id="806938"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="280502"
                                                    id="280502"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Icon
                                                      key="895601"
                                                      id="895601"
                                                      iconName="add_shopping_cart"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "20px",
                                                          color:
                                                            "rgba(140, 140, 140, 1)",
                                                          letterSpacing: "1px",
                                                        } as any
                                                      }
                                                    ></Icon>
                                                    <Label
                                                      key="663528"
                                                      id="663528"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        663528,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="103368"
                                                      id="103368"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        103368,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 200,
                                                          borderTopRightRadius: 200,
                                                          borderBottomRightRadius: 200,
                                                          borderBottomLeftRadius: 200,
                                                          backgroundColor:
                                                            "rgba(13, 150, 212, 0.22)",
                                                          paddingTop: 4,
                                                          paddingRight: 8,
                                                          paddingBottom: 4,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(13, 150, 212, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                      </KTab>
                    </Form.Item>
                  </KCol>
                </KRow>
              </div>
            </div>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(ProjeDetay_Screen)
        )
      )
    )
  )
);
export { tmp as ProjeDetay_Screen };
//export default tmp;
//export { tmp as ProjeDetay_Screen };
